import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { groupStyles } from '../../../../utils/SelectStyles';
import Button from '../../../../components/Common/Buttons/Button';

const option = [
	{ label: 'Serviceline', value: 'SERVICELINE', placeholder: 'Search account by Serviceline' },
	{ label: 'Account Number', value: 'ACCOUNT NUMBER', placeholder: 'Search account by Account Number' },
	{ label: 'Name', value: 'NAME', placeholder: 'Search account by Name' },
	{ label: 'Address', value: 'ADDRESS', placeholder: 'Search account by Address' },
	{ label: 'Equipment', value: 'EQUIPMENT', placeholder: 'Search account by Equipment' },
	{ label: 'Company', value: 'COMPANY', placeholder: 'Search account by Company' },
	{ label: 'Contact number', value: 'CONTACT NUMBER', placeholder: 'Search account by Contact Number' },
	{ label: 'Email', value: 'EMAIL', placeholder: 'Search account by Email' },
	{ label: 'Account Id', value: 'ACCOUNT ID', placeholder: 'Search account by Account Id' },
	{ label: 'Order Id', value: 'ORDER ID', placeholder: 'Search account by Order Id' },
	{ label: 'Service Order Id', value: 'SERVICE ORDER ID', placeholder: 'Search account by Service Order Id' }
];

const SearchBar = ({
					   searchAccounts,
					   changeSearchType,
					   changeTerm,
					   term,
					   searchType,
					   placeholder,
					   getCustomersServedHistory,
					   history,
					   newAccountPermission,
					   searchHistoryPermissions,
					   isLoading,
					   updateFilters,
					   accountStatusOptions,
					   accountTermsFilterOptions,
					   accountTypesFilterOptions,
					   filters
				   }) => {

	const [showFilters, setShowFilters] = useState(false);
	const [isLoadingOptions, setIsLoadingOptions] = useState(true);

	useEffect(() => {
		const { accountType, accountStatus, accountTerm } = filters;
		if (accountType || accountStatus || accountTerm) {
			setShowFilters(true);
		}

		if (Array.isArray(accountTypesFilterOptions) && Array.isArray(accountTermsFilterOptions)) {
			setIsLoadingOptions(false);
		}
	}, [filters, accountTypesFilterOptions, accountTermsFilterOptions]);

	const filterOnChangeHandler = (e, type) => {
		if (e) {
			switch (type) {
				case "accountStatus":
					updateFilters("accountStatus", e.value);
					break;
				case "accountType":
					updateFilters("accountType", e.value);
					break;
				case "accountTerm":
					updateFilters("accountTerm", e.value);
					break;
			}
		} else {
			// Clears combo-boxes
			switch (type) {
				case "accountStatus":
					updateFilters("accountStatus", "");
					break;
				case "accountType":
					updateFilters("accountType", "");
					break;
				case "accountTerm":
					updateFilters("accountTerm", "");
					break;
			}
		}
	}

	return (
		<div className="cmv-container-dashboard-search">
			<div className="cmv-container-dashboard-filter">
				<div className="container">
					<div className="form-row">
						<div className="col-md-3">
							<Select
								id="searchType"
								name="searchType"
								value={searchType}
								onChange={changeSearchType}
								options={option}
								placeholder="Search"
								styles={groupStyles}
								isDisabled={isLoading || isLoadingOptions}
								isLoading={isLoadingOptions}
							/>
						</div>
						<div class="col-md-9">
							<div class="input-group">
								<input
									type="text"
									id="term"
									name="term"
									className="form-control"
									placeholder={placeholder}
									onChange={changeTerm}
									value={term}
									autoComplete="off"
									disabled={isLoading}
									onKeyPress={(event) => {
										if (event.key === 'Enter') {
											searchAccounts();
										}
									}}
								/>

								<div class="input-group-append">
									{searchHistoryPermissions && (
										<Button
											type="button"
											className="btn btn-primary btn-show-cam-search-results"
											disabled={isLoading}
											onClick={searchAccounts}
										>
											<i className="fas fa-search" />
											<span>&nbsp;Search</span>
										</Button>
									)}
								</div>

								<div class="input-group-append">
									<div className="btn-group">
										<Button
											type="button"
											onClick={() => setShowFilters(!showFilters)}
											className="btn btn-outline-secondary"
										>
											{showFilters ? (
												<i className="fas fa-solid fa-ban" />
											) : (
												<i className="fas fa-solid fa-filter" />
											)}
											<span>&nbsp;Filters</span>
										</Button>
										{searchHistoryPermissions && (
											<Button
												type="button"
												onClick={getCustomersServedHistory}
												className="btn btn-outline-secondary btn-show-cam-search-history"
												disabled={isLoading}
											>
												<i className="fas fa-history" />
												<span>&nbsp;History</span>
											</Button>
										)}
										{newAccountPermission && (
											<Button
												type="button"
												onClick={() => history.push('/create-account')}
												className="btn btn-outline-secondary btn-new-account-wizard"
											>
												<i className="fas fa-plus" />
												<span>&nbsp;New Account</span>
											</Button>
										)}
									</div>
								</div>
							</div>
						</div>
						{showFilters && (
							<>
								<div className="col-md-3" style={{ paddingTop: '15px' }}>
									<Select
										className="extra-filter-select"
										onChange={(e) => filterOnChangeHandler(e, "accountStatus")}
										styles={groupStyles}
										options={Array.isArray(accountStatusOptions) ? accountStatusOptions.map(option => ({
											label: option,
											value: option,
											placeholder: option,
										})) : []}
										placeholder="Account Status"
										value={filters.accountStatus.length !== 0 ? {
											label: filters.accountStatus,
											value: filters.accountStatus,
										} : ''}
										isClearable={filters.accountStatus.length}
										isLoading={isLoadingOptions}
										isDisabled={isLoadingOptions}
									/>
								</div>
								<div className="col-md-3" style={{ paddingTop: '15px' }}>
									<Select
										className="extra-filter-select"
										onChange={(e) => filterOnChangeHandler(e, "accountType")}
										styles={groupStyles}
										options={Array.isArray(accountTypesFilterOptions) ? accountTypesFilterOptions.map(option => ({
											label: option.description,
											placeholder: option.description,
											value: option.name,
										})) : []}
										placeholder="Account Type"
										value={filters.accountType.length !== 0 ? {
											label: filters.accountType,
											value: filters.accountType,
										} : ''}
										isClearable={filters.accountType.length}
										isLoading={isLoadingOptions}
										isDisabled={isLoadingOptions}
									/>
								</div>
								<div class="col-md-3" style={{ paddingTop: '15px' }}>
									<Select
										className="extra-filter-select"
										onChange={(e) => filterOnChangeHandler(e, "accountTerm")}
										styles={groupStyles}
										options={Array.isArray(accountTermsFilterOptions) ? accountTermsFilterOptions.map(option => ({
											label: option.description,
											placeholder: option.description,
											value: option.name,
										})) : []}
										placeholder="Account Terms"
										value={filters.accountTerm.length !== 0 ? {
											label: filters.accountTerm,
											value: filters.accountTerm,
										} : ''}
										isClearable={filters.accountTerm.length}
										isLoading={isLoadingOptions}
										isDisabled={isLoadingOptions}
									/>
								</div>
							</>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

SearchBar.propTypes = {
	searchAccounts: PropTypes.func,
	changeSearchType: PropTypes.func,
	changeTerm: PropTypes.func,
	searchType: PropTypes.object,
	term: PropTypes.string,
	placeholder: PropTypes.string,
	getCustomersServedHistory: PropTypes.func,
	history: PropTypes.object,
	newAccountPermission: PropTypes.bool,
	searchHistoryPermissions: PropTypes.bool,
	isLoading: PropTypes.bool,
	updateFilters: PropTypes.func,
	accountStatusOptions: PropTypes.array,
	accountTermsFilterOptions: PropTypes.array,
	accountTypesFilterOptions: PropTypes.array,
	filters: PropTypes.object,
};

export default SearchBar;